const host =
  process.env.NODE_ENV === "development"
    ? `api.fluxqr.dev`
    : "api.fluxqr.com";

const url = (path) =>
  `https://${host}/v3${String(path)[0] === "/" ? path : `/${path}`}`;

export { url };
